import Loadable from "react-loadable";

export const AddCompanyButton = Loadable({
  loader: () => import("../../../../modules/manage-profile").then((module) => module.AddCompanyButton) as Promise<any>,
  loading: () => null,
});
